var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcclusalLower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 112.476,
    height: 92.52,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 161 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer_x0020_1",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "square",
    strokeWidth: 0.953607,
    d: "M10 1C8 2 8 1 6 3 3 8 4 9 2 13v3c-1 7 1 6 4 8h10c2-1 3-2 5-4 1-2 2-7 2-9-1-6-4-9-9-10h-4M6 24c-1 1-5 3-5 5-1 1 0 4 0 5 1 4 2 6 3 10 1 2 2 2 3 3 2 0 4-1 6-1h4c2-1 3-2 3-4l1-7c-2-10-3-8-5-11M7 47c-2 1-4 3-4 7 1 1 2 6 2 7 2 3 2 5 4 7 1 3 2 3 4 3l1-1c4-3 4-3 8-4l2-2c1-2-1-12-1-13-2-2-5-4-6-5m17 42c3 0 5 1 8 4 1 3 3 4 4 7 1 2-1 6-1 7l-2 1-1 1c-2 0-3 1-4 1l-6-3c-1-1-5-6-5-9-1-3 1-3 1-5l2-2 1-1c1 0 2-1 3-1 0-1 1-3 1-4-1-1-1 0-1-1-1-4-4-9-4-12-1-1-4-4-6-5h-2m6 26c-4 1-8-3-11-6-2-3-6-9-5-13 1-1 1-1 1-2m29 37c-1 2-4 7 0 11 3 4 8 2 10 2 0 1 0 2 1 3l2 3c1 0 6 2 8 1h2c1 1 2 1 3 2s10 4 12-1v-1c-1-2-2-8-2-9-1-1-2-3-4-3s-7 8-8 8c0-1 0 0-1-1 0-3 1-8-2-11h-2c-1 1-5 4-7 5 0-4 3-7-1-11h-8m7 15v-2l1-1c1 0 1-1 1-1m11 11v-2c1-1 1 0 1-2m29 0c0 1 1 2 1 4-1 0-1 1-2 1-2 2-8 4-11 2l-2-1v-3l3-9c0-1 2-2 2-2 2 0 8 8 9 8 1-1 1-9 1-10l2-2h2c1 1 5 4 7 5-1-4-2-8 1-11h8c0-1-1-2-1-4v-4s6-8 7-9 4-1 6-1c0 0 1 1 2 1l1 1 2 2c8 2 15-12 16-16 0-2-1-3-1-5 1 0 2 0 3-1l2-2c1-1 5-14 5-15l-1-3c-1-2-2-1-3-3-1 0-5-1-6-1h-4c-4-3-3-2-3-4-1-4-1-12 1-15l3-3h1c2 1 5 0 7 0h2c1-1 4-1 4-5v-7c-1-3-3-9-6-10-1-1-4-1-6-1s-4 1-4 1l-3 3c-1 2-2 8-1 11 0 3 2 6 4 7 1 0 1 1 2 1m9 23c0-1 1-1 1-1 3-2 7-14 5-18-2-2-3-2-5-4m-7 47-2-1c-3-3-4-3-8-4 0-1-2-2-1-4l1-10c1-3 5-5 6-6m-6 20s-2 0-3 1c-2 2-3 2-4 4-2 4-4 8-5 12 0 2 1 4 2 5m-12 18c1 1 1 1 2 1 1 1 0 1 1 1 3 0 4 2 10-2 2-2 6-8 5-11l-1-3m-26 25c1 1 2 2 2 4 1 0 7 2 10-2s2-7 0-11m-23 20c1 0 2 1 4 0 4 0 9-3 9-7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcclusalLower);
export default __webpack_public_path__ + "static/media/OcclusalLower.1d1a5a3ad3a6a0b057f3b15bcdff8aed.svg";
export { ForwardRef as ReactComponent };